import React from 'react';
import IECModuleForm from './IECModuleForm';
import { useSearchParams } from 'react-router-dom';

const AddIECModule = () => {
  const [serachParams] = useSearchParams();
  const tab = serachParams.get('tab');
  if (tab === 'add') {
    // document.title = "Add IEC Module"
    return <IECModuleForm  />;
  } else {
    return null;
  }
};

export default AddIECModule;
